import * as React from "react";
import { Box, styled, useMediaQuery } from "@mui/system";
import {
  Button,
  AppBar,
  Toolbar,
  Drawer,
  SvgIcon,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
} from "@mui/material";
import { useState } from "react";
import ecoisAPI from "../../../api/ecois";
import Swal from "sweetalert2";
import biosenseAPI, { handleError as handleBiosenseError } from "../../../api/biosense";
import LoginForm from "./loginForm";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/languageSwitcher";
import { ReactComponent as Logo } from "../../../assets/greenwallslogo.svg";
import { ReactComponent as GWIN } from "../../../assets/gwin.svg";
import cardOrListTheme from "../../../assets/cardOrListTheme";
import { TableRows } from "@mui/icons-material";

const now = Date.now();
const theme = cardOrListTheme;

const TopBar = ({ setState }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoginDrawerOpen, setIsLoginDrawerOpen] = useState(false);
  const handleLoginDrawerOpen = () => {
    setIsLoginDrawerOpen(true);
  };
  const handleLoginDrawerClose = () => {
    setIsLoginDrawerOpen(false);
  };
  async function onLogin({ username, password }) {
    try {
      const biosenseRes = await biosenseAPI.login({ username, password });
      const tokenExpiresAt = now + biosenseRes.expires * 1000;
      const token = biosenseRes.token;
      localStorage.setItem("tokenExpiresAt", tokenExpiresAt);
      localStorage.setItem("token", token);
      navigate("/");
      Swal.fire(
        "成功",
        `<div style='flex flex-start'><h4>登錄資料</h4>登錄有效時間: ${new Date(
          tokenExpiresAt,
        ).toLocaleString("zh-CN")}</div>`,
      );

      const ecoisRes = await ecoisAPI.login();
      const ecois_tokenExpiresAt = now + ecoisRes.expires * 1000;
      const ecois_token = ecoisRes.token;
      localStorage.setItem("ecois_tokenExpiresAt", ecois_tokenExpiresAt);
      localStorage.setItem("ecois_token", ecois_token);
      handleLoginDrawerClose();
    } catch (err) {
      console.log(err);
      handleBiosenseError(err);
    }
  }

  const scrollToSection = (pageTab, sectionId) => {
    setState({ pageTab: pageTab });
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 100;
      const targetPosition = element.offsetTop - offset;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 0,
      });
    }
  };

  const isDev = process.env.NODE_ENV === "development";

  //// Phone UI
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOnClickTab = (callback) => {
    callback();
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  if (isPhone) {
    return (
      <StyledAppBar position='static'>
        <StyledToolbar>
          <IconButton color='inherit' onClick={handleClick}>
            <TableRows />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            {isDev && (
              <>
                <MenuItem
                  onClick={() => handleOnClickTab(() => scrollToSection("entry", "about-8p"))}
                >
                  <ListItemText primary={t("landing.topbar_about8p")} />
                </MenuItem>
                <MenuItem
                  onClick={() => handleOnClickTab(() => scrollToSection("entry", "clients"))}
                >
                  <ListItemText primary={t("landing.topbar_clients")} />
                </MenuItem>
                <MenuItem
                  onClick={() => handleOnClickTab(() => scrollToSection("entry", "contact"))}
                >
                  <ListItemText primary={t("landing.topbar_contact")} />
                </MenuItem>
              </>
            )}
            <MenuItem
              onClick={() => handleOnClickTab(() => scrollToSection("changelog", undefined))}
            >
              <ListItemText primary={t("landing.topbar_changelog")} />
            </MenuItem>
          </Menu>
          <IconButton onClick={() => scrollToSection("entry", undefined)}>
            <SvgIcon>
              <Logo />
            </SvgIcon>
          </IconButton>
          <Box sx={{ flexGrow: 1 }}>
            <Button color='inherit' onClick={() => scrollToSection("entry", "gwin-biosense")}>
              <GWIN width='50' height='auto' />
            </Button>
          </Box>
          <LanguageSwitcher />
          <Button id='login-button' onClick={handleLoginDrawerOpen} color='inherit'>
            {t("landing.topbar_login")}
          </Button>
        </StyledToolbar>
        <Drawer anchor='bottom' open={isLoginDrawerOpen} onClose={handleLoginDrawerClose}>
          <div style={{ padding: "16px", display: "flex" }}>
            <ScreenBackground>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <LoginForm onLogin={onLogin} />
              </div>
            </ScreenBackground>
          </div>
        </Drawer>
      </StyledAppBar>
    );
  }
  //// ---------

  return (
    <StyledAppBar position='static'>
      <StyledToolbar>
        <IconButton onClick={() => scrollToSection("entry", undefined)}>
          <SvgIcon>
            <Logo />
          </SvgIcon>
        </IconButton>
        <Box sx={{ flexGrow: 1 }}>
          <Button color='inherit' onClick={() => scrollToSection("entry", "gwin-biosense")}>
            <GWIN width='50' height='auto' />
          </Button>
          {isDev && (
            <>
              <Button color='inherit' onClick={() => scrollToSection("entry", "about-8p")}>
                {t("landing.topbar_about8p")}
              </Button>
              <Button color='inherit' onClick={() => scrollToSection("entry", "clients")}>
                {t("landing.topbar_clients")}
              </Button>
              <Button color='inherit' onClick={() => scrollToSection("entry", "contact")}>
                {t("landing.topbar_contact")}
              </Button>
            </>
          )}

          <Button color='inherit' onClick={() => scrollToSection("changelog", undefined)}>
            {t("landing.topbar_changelog")}
          </Button>
        </Box>
        <LanguageSwitcher />
        <Button
          id='login-button'
          onClick={handleLoginDrawerOpen}
          color='inherit'
          sx={{ paddingRight: "2em" }}
        >
          {t("landing.topbar_login")}
        </Button>
      </StyledToolbar>
      <Drawer anchor='right' open={isLoginDrawerOpen} onClose={handleLoginDrawerClose}>
        <div style={{ padding: "16px", width: 300 }}>
          <ScreenBackground>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <LoginForm onLogin={onLogin} />
            </div>
          </ScreenBackground>
        </div>
      </Drawer>
    </StyledAppBar>
  );
};

const ScreenBackground = styled("div")({
  borderRadius: "4px",
  backgroundColor: "#fff",
  flex: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const StyledAppBar = styled(AppBar)({
  backgroundColor: "rgba(0, 0, 0, 0.7)", // Black with transparency
  position: "fixed",
  top: 0,
  zIndex: 3,
  boxSizing: "border-box",
  minWidth: "100vw",
  minHeight: "64px",
});

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export default TopBar;
